import _slicedToArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.entries.js";
import SourceArea from './SourceArea';
import Brand from './Brand';
import Category from './Category';
import Transport from './Transport';
import Link from './Link';
import Menu from './Menu';
import SimpleLink from "./SimpleLink";
import SimpleCategory from "./SimpleCategory";
import Vue from 'vue';
var coms = {
  SourceArea: SourceArea,
  // 原产地
  Brand: Brand,
  // 品牌
  Category: Category,
  // 分类
  Transport: Transport,
  // 运输方式
  Link: Link,
  // 链接
  Menu: Menu,
  // 菜单
  SimpleLink: SimpleLink,
  SimpleCategory: SimpleCategory
};
for (var _i = 0, _Object$entries = Object.entries(coms); _i < _Object$entries.length; _i++) {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
    key = _Object$entries$_i[0],
    value = _Object$entries$_i[1];
  Vue.component(key, value);
}